import HomeDashboard from 'src/pages/HomeDashboard';
import Coupons from 'src/pages/Coupons';
import DescriptionLocation from 'src/pages/DescriptionLocation';
import MigrateFeedElement from 'src/pages/MigrateFeedElement';
import AnalogInventory from 'src/pages/AnalogInventory';
import HabiLeadsSellersPage from 'src/pages/HabiLeadsSellers';
import ScoringPrograms from 'src/pages/ScoringPrograms';
import ProgramsAssignment from 'src/pages/ProgramsAssignment';
import Prospects from 'src/pages/Prospects';
import Retention from 'src/pages/Retention';
import QualifyPropertyHabiPage from 'src/pages/QualifyPropertyHabi';
import Frauds from 'src/pages/Frauds';
import NotificationManagerPage from 'src/pages/NotificationManager';
import OrphanAssigment from 'src/pages/OrphanAssigment';
import ProductAssignment from 'src/pages/ProductAssignment';

export const listRoutes = [
    { path: '/', Component: HomeDashboard },
    { path: '/coupons', Component: Coupons },
    { path: '/description-location', Component: DescriptionLocation },
    { path: '/migrate-feed', Component: MigrateFeedElement },
    { path: '/habi-leads-sellers', Component: HabiLeadsSellersPage },
    { path: '/qualify-property-for-habi', Component: QualifyPropertyHabiPage },
    { path: '/analog-inventory', Component: AnalogInventory },
    { path: '/scoring-programs', Component: ScoringPrograms },
    { path: '/programs-assignment', Component: ProgramsAssignment },
    { path: '/product-assignment', Component: ProductAssignment },
    { path: '/brokers-configurations', Component: OrphanAssigment },
    { path: '/prospects', Component: Prospects, isCustomerSuccess: true },
    { path: '/retention', Component: Retention, isCustomerSuccess: true },
    { path: '/fraud-users', Component: Frauds, isCustomerSuccess: true },
    { path: '/notifications', Component: NotificationManagerPage, isCustomerSuccess: true },
];
